/**
 * Normalise un numéro mobile Maroc (et formats proches) vers des chiffres internationaux sans +.
 * Ex. +212611159538, 212611159538, 0611159538, 611159538 → 212611159538
 */
export function normalizePhoneDigits(phone) {
  if (phone == null || phone === '') return '';
  let d = String(phone).replace(/\D/g, '');
  if (!d) return '';
  if (d.startsWith('00')) d = d.slice(2);
  // National 06xxxxxxxx (10 chiffres)
  if (d.startsWith('0') && d.length === 10) d = '212' + d.slice(1);
  // 9 chiffres sans indicatif
  if (d.length === 9 && !d.startsWith('212')) d = '212' + d;
  return d;
}

/**
 * Partie « nationale » après 212 (ex. 611159538) pour matcher 06… ou 611…
 */
function nationalMobileDigits(normStored) {
  if (normStored.startsWith('212') && normStored.length >= 12) return normStored.slice(3);
  return normStored;
}

/**
 * Indique si la saisie (indicatif, 06…, espaces) correspond au numéro stocké.
 * +212611159538, 212611159538, 0611159538, 611159538 sont équivalents.
 */
export function phoneSearchMatches(storedPhone, rawInput) {
  const raw = String(rawInput || '').trim();
  if (!raw) return true;

  const qDigits = raw.replace(/\D/g, '');
  const normStored = normalizePhoneDigits(storedPhone);
  if (!normStored) return false;
  if (!qDigits) return false;

  const normQuery = normalizePhoneDigits(qDigits);
  if (normQuery && normStored === normQuery) return true;
  if (normQuery.length >= 12 && normStored.includes(normQuery)) return true;

  const national = nationalMobileDigits(normStored);
  const withoutLeadingZero = qDigits.startsWith('0') ? qDigits.slice(1) : qDigits;
  if (withoutLeadingZero.length >= 2 && national.startsWith(withoutLeadingZero)) return true;

  if (qDigits.length >= 3 && national.includes(qDigits)) return true;
  if (qDigits.length >= 4 && normStored.includes(qDigits)) return true;

  return false;
}
